var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGift48Filled = function SvgIconGift48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 16.3h-.19c.31-.7.49-1.48.49-2.3 0-2.59-2.11-4.7-4.7-4.7-1.99 0-3.77.88-5 2.26-1.23-1.38-3.01-2.26-5-2.26-2.59 0-4.7 2.11-4.7 4.7 0 .82.18 1.6.49 2.3h-.19a5.31 5.31 0 0 0-5.3 5.3v11.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V21.6c0-2.92-2.38-5.3-5.3-5.3ZM17.7 14c0-.72.58-1.3 1.3-1.3 1.82 0 3.3 1.48 3.3 3.3v.3H20a2.3 2.3 0 0 1-2.3-2.3Zm8 21.3h-3.4V19.7h3.4v15.6Zm2.3-19h-2.3V16c0-1.82 1.48-3.3 3.3-3.3.72 0 1.3.58 1.3 1.3a2.3 2.3 0 0 1-2.3 2.3Z",
    fill: "current"
  })));
};
export default SvgIconGift48Filled;